<template>
  <div
    class="badge-state"
    :class="{
      'badge-state-blue': (this.params.data.state == 'Draft'),
      'badge-state-yellow': (this.params.data.state == 'Waiting for Approval'),
      'badge-state-green': (this.params.data.state == 'Approved'),
      'badge-state-red': (this.params.data.state == 'Rejected') || (this.params.data.state == 'Expired')
    }"
  >
    {{ this.params.data.state }}
  </div>
</template>

<script>
  /* eslint-disable */
  import { onBeforeMount, ref } from '@vue/runtime-core'
  import { mdiCheckCircle, mdiCheckCircleOutline } from '@mdi/js'
  import CryptoJS from 'crypto-js'

export default {
  name: 'Button Status',

  setup (props) {
    onBeforeMount(() => {

    })

    return {
    }
  },
  methods: {
    activate (event) {
      // the grid component can now be accessed via this.params.context.componentParent
      this.params.context.componentParent.activate(event, this.params.data)
    }
  }

}
</script>

<style lang="scss" scoped>
  .badge-state {
    width: max-content;
    height: 32px;
    margin: 3px auto 0 auto;
    padding: 0 16px;
    border-radius: 8px;
    background-color: lightgray;
    border: 2px solid gray;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    font-weight: 500;
  }

  .badge-state-blue {
    background-color: #1a53ff;
    border: 2px solid #0040ff;
    color: white;
  }

  .badge-state-yellow {
    background-color: #ffc934;
    border: 2px solid #ffbb00;
    color: black;
  }

  .badge-state-green {
    background-color: #15b200;
    border: 2px solid #108c00;
    color: white;
  }

  .badge-state-red {
    background-color: #d40000;
    border: 2px solid #aa0000;
    color: white;
  }
</style>
